module.exports = __webpack_public_path__ + "static/img/J.b705fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/J.png
// module id = DUDd
// module chunks = 0